export const providers = [
  {
    id: 'AWS',
    label: 'AWS',
    platform: 'AWS',
    cloud_provider: 'TGCloud',
  },
  {
    id: 'AWS-BYOC',
    label: 'AWS BYOC',
    platform: 'AWS',
    cloud_provider: 'BYOC',
  },
  {
    id: 'GCP',
    label: 'GCP (Coming soon)',
    disabled: true,
    platform: 'AWS',
    cloud_provider: 'TGCloud',
  },
  {
    id: 'Azure',
    label: 'Azure (Coming soon)',
    disabled: true,
    platform: 'AWS',
    cloud_provider: 'TGCloud',
  },
] as const;

export const regions = [
  {
    id: 'us-east-1',
    label: 'US East (N. Virginia) - Tier 1',
  },
  {
    id: 'us-east-2',
    label: 'US East (Ohio) - Tier 1',
  },
  {
    id: 'us-west-2',
    label: 'US West (Oregon) - Tier 1',
  },
  {
    id: 'eu-central-1',
    label: 'Europe (Frankfurt) - Tier 3',
  },
  {
    id: 'eu-west-1',
    label: 'Europe (Ireland) - Tier 2',
  },
  {
    id: 'eu-west-2',
    label: 'Europe (London) - Tier 2',
  },
  {
    id: 'sa-east-1',
    label: 'South America (São Paulo) - Tier 4',
  },
  {
    id: 'ap-southeast-1',
    label: 'Asia Pacific (Singapore) - Tier 3',
  },
  {
    id: 'ap-southeast-2',
    label: 'Asia Pacific (Sydney) - Tier 3',
  },
  {
    id: 'ap-northeast-1',
    label: 'Asia Pacific (Tokyo) - Tier 3',
  },
];

// the cost_per_hour/cost_per_hour_with_ha are just place holder
export const workspaceSizes = [
  {
    typeName: 'TG-00',
    cpu: '2',
    memory: '16Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-0',
    cpu: '4',
    memory: '32Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-1',
    cpu: '8',
    memory: '64Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-2',
    cpu: '16',
    memory: '128Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-4',
    cpu: '32',
    memory: '256Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-6',
    cpu: '48',
    memory: '384Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-8',
    cpu: '64',
    memory: '512Gi',
    partition: 1,
    ha: 3,
  },
  {
    typeName: 'TG-16',
    cpu: '128',
    memory: '1024Gi',
    partition: 2,
    ha: 2,
  },
  {
    typeName: 'TG-24',
    cpu: '192',
    memory: '1536Gi',
    partition: 3,
    ha: 2,
  },
  {
    typeName: 'TG-32',
    cpu: '256',
    memory: '2048Gi',
    partition: 4,
    ha: 2,
  },
  {
    typeName: 'TG-40',
    cpu: '320',
    memory: '2560i',
    partition: 5,
    ha: 2,
  },
  {
    typeName: 'TG-48',
    cpu: '384',
    memory: '3072Gi',
    partition: 6,
    ha: 2,
  },
  {
    typeName: 'TG-56',
    cpu: '448',
    memory: '3584Gi',
    partition: 7,
    ha: 2,
  },
  {
    typeName: 'TG-64',
    cpu: '512',
    memory: '4096Gi',
    partition: 8,
    ha: 2,
  },
];
